import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { domainUrl } from "../../../constants/apiconstans/domanUrl";
import { Alert } from "../../../../components";

export const getAllClientsEndResult = createAsyncThunk(
  "clientsEndResult",
  async (obj, { dispatch, getState }) => {
    const tokenString = localStorage.getItem("token");
    const userToken = JSON.parse(tokenString);
    dispatch(gettingClientsEndResult());
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("pageNo", obj?.pageNo);
    myHeaders.append("recordsPerPage", obj?.pageSize);
    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
      body: JSON.stringify({ name: obj?.name, age: obj?.age }),
    };
    fetch(domainUrl + `/ViewAllClientEndResult`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success) {
          let tempArr = [];
          // if(result?.clientEndResults)
          // {
          //     tempArr=[
          //         ...result?.clientEndResults?.map(data=>(
          //             {
          //                 ...data,
          //                 file:JSON.parse(data?.file),
          //             }
          //         ))
          //     ]
          // }
          dispatch(clientsEndResultResponse(result?.clientEndResults));
          dispatch(
            setPages({
              pageNo: obj?.pageNo,
              pageSize: obj?.pageSize,
              totalRecords: result?.totalRecords,
            }),
          );
        } else {
          dispatch(clientsEndResultClear());
          Alert("error", result?.message);
        }
      })
      .catch((error) => {
        alert(error);
        dispatch(clientsEndResultClear());
        Alert("error", "error while loading Clients End Results");
      });
  },
);

const ClientsEndResultSlice = createSlice({
  name: "ClientsEndResult",
  initialState: {
    data: [],
    loading: false,
    pagination: {
      pageNo: 1,
      pageSize: 10,
      totalRecords: 0,
    },
    filters: {
      name: "",
      age: "",
    },
  },
  reducers: {
    gettingClientsEndResult: (state, action) => {
      state.loading = true;
      state.data = [];
    },
    clientsEndResultResponse: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    clientsEndResultClear: (state, action) => {
      state.data = [];
      state.loading = false;
    },
    changeDetailFilters: (state, action) => {
      state.filters = action.payload;
    },
    setPages: (state, action) => {
      state.pagination = action.payload;
    },
  },
});

export const {
  gettingClientsEndResult,
  clientsEndResultResponse,
  clientsEndResultClear,
  setPages,
  changeDetailFilters,
} = ClientsEndResultSlice.actions;
export default ClientsEndResultSlice.reducer;
